/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Done': {
    width: 15,
    height: 12,
    viewBox: '0 0 15 12',
    data: '<path pid="0" d="M13.654 3.26l-7.415 7.744a1.315 1.315 0 01-.968.408c-.343 0-.687-.13-.952-.408L.604 7.141c-.53-.57-.53-1.467 0-2.022a1.334 1.334 0 011.936 0L5.27 7.972l6.447-6.733a1.334 1.334 0 011.936 0c.53.571.53 1.468 0 2.022z" _fill="#fff"/>'
  }
})
